// ignore-string-externalization
import React from 'react';
import styled from 'styled-components';
import { screenSmMin, display1FontSizeXSmall, heading2FontSize, spacer8, spacer20, spacer40, Type } from '@spotify-internal/encore-web';
import { ContentfulImage } from '../../../Contentful/ContentfulImage';
import { DELAYS, Box, fadeInAnimation, ImageAspectBox1x1, withAnimationContext } from '../../../ui';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
var HeroCaseStudyCover = styled(Box).withConfig({
  displayName: "HeroCaseStudy__HeroCaseStudyCover",
  componentId: "sc-1r0rsq1-0"
})(["color:", ";height:auto;&.tallest{height:100%;}background-image:url(\" data:image/svg+xml,%3Csvg stroke-width='0.40' viewBox='100 20 757 501' fill='none' xmlns='http://www.w3.org/2000/svg'%3E%3Cpath d='M0.999962 322.841L415.367 -9L337.576 217.561L484.861 125.057L385.807 502L865 226.049' stroke='%23", "'/%3E%3C/svg%3E\");background-position:center center;background-size:cover;background-repeat:no-repeat;background-color:", ";@media (max-width:", "){background-image:none;padding-bottom:", ";}"], function (props) {
  return props.textColor;
}, function (props) {
  return props.textColor ? props.textColor.substring(1) : props.textColor;
}, function (props) {
  return props.backgroundColor;
}, screenSmMin, spacer40);
var HeroCaseStudyWrapper = styled.div.withConfig({
  displayName: "HeroCaseStudy__HeroCaseStudyWrapper",
  componentId: "sc-1r0rsq1-1"
})(["padding-top:", ";display:flex;flex-direction:row;align-items:flex-end;flex-wrap:wrap;height:auto;align-self:center;text-align:", ";@media (max-width:", "){padding-top:0px;flex-direction:column;align-items:flex-start;}"], spacer20, function (props) {
  return props.centered ? 'center' : 'left';
}, screenSmMin); // TODO Remove hardcoding of font-size and line-height for mobile and web

var StyledHeadline = withAnimationContext(styled(Type.h1).attrs({
  variant: Type.heading1,
  weight: Type.bold
}).withConfig({
  displayName: "HeroCaseStudy__StyledHeadline",
  componentId: "sc-1r0rsq1-2"
})(["", ";font-size:", ";line-height:56px;height:100%;padding-left:", ";padding-bottom:0;align-self:flex-start;text-transform:none;@media (max-width:", "){width:100%;padding-left:0;font-size:", ";line-height:40px;}"], fadeInAnimation(DELAYS.SECOND), display1FontSizeXSmall, spacer40, screenSmMin, heading2FontSize));
var ImageWrapper = styled(ImageAspectBox1x1).withConfig({
  displayName: "HeroCaseStudy__ImageWrapper",
  componentId: "sc-1r0rsq1-3"
})(["width:35%;display:flex;align-items:center;@media (max-width:", "){width:100%;margin-bottom:", ";}"], screenSmMin, spacer8);
var StyledSupertext = withAnimationContext(styled(Type.p).attrs({
  variant: Type.body1,
  weight: Type.bold
}).withConfig({
  displayName: "HeroCaseStudy__StyledSupertext",
  componentId: "sc-1r0rsq1-4"
})(["", ";padding-left:", ";padding-bottom:", ";text-transform:uppercase;@media (max-width:", "){padding-top:", ";padding-left:0;width:100%;}"], fadeInAnimation(DELAYS.FIRST), spacer40, spacer8, screenSmMin, spacer8));
var Right = styled.div.withConfig({
  displayName: "HeroCaseStudy__Right",
  componentId: "sc-1r0rsq1-5"
})(["width:55%;display:flex;flex-direction:column;padding-left:", ";align-self:center;@media (max-width:", "){width:100%;padding-left:0px;padding-top:", ";justify-content:flex-start;}"], spacer40, screenSmMin, spacer8);
export var HeroCaseStudy = /*#__PURE__*/React.forwardRef(function (_ref, ref) {
  var _ref$supertext = _ref.supertext,
      supertext = _ref$supertext === void 0 ? '' : _ref$supertext,
      _ref$headline = _ref.headline,
      headline = _ref$headline === void 0 ? '' : _ref$headline,
      image = _ref.image,
      _ref$backgroundColor = _ref.backgroundColor,
      backgroundColor = _ref$backgroundColor === void 0 ? '' : _ref$backgroundColor,
      _ref$textColor = _ref.textColor,
      textColor = _ref$textColor === void 0 ? '' : _ref$textColor;
  return /*#__PURE__*/_jsx(HeroCaseStudyCover, {
    backgroundColor: backgroundColor,
    textColor: textColor,
    ref: ref,
    children: /*#__PURE__*/_jsxs(HeroCaseStudyWrapper, {
      centered: image === undefined,
      children: [image && /*#__PURE__*/_jsx(ImageWrapper, {
        children: /*#__PURE__*/_jsx(ContentfulImage, {
          asset: image
        })
      }), /*#__PURE__*/_jsxs(Right, {
        children: [/*#__PURE__*/_jsx(StyledSupertext, {
          children: supertext
        }), /*#__PURE__*/_jsx(StyledHeadline, {
          children: headline
        })]
      })]
    })
  });
});